import { useState } from 'react'
import moment from 'moment'
import { APP_LANGUAGE } from '../../../localized-urls'
import { isMobile } from '../../../utils'

import styles from './Calendar.module.scss'
import cx from 'classnames'

const isMobileDemention = isMobile()

const monthes = moment.localeData('en').months()

const monthesShort = moment.localeData(APP_LANGUAGE).monthsShort()

const CalendarContentRow = ({ element }) => {
  const define = (prop) => {
    switch (prop) {
      case 10:
        return <div className={cx(styles.item, styles.unlikely)} />
      case 20:
        return <div className={cx(styles.item, styles.possible)} />
      default:
        return <div className={cx(styles.item, styles.most)} />
    }
  }

  return (
    <div className={styles.itemContent}>
      <div className={styles.itemContentTitle}>{element.title}</div>
      <div className={styles.itemContentRow}>
        {monthes.map((month) => (
          <div key={month} className={styles.itemContentCol}>
            {define(element[month.toLowerCase()])}
          </div>
        ))}
      </div>
    </div>
  )
}

export const CalendarGroupItem = ({ group }) => {
  const [isToggled, setToggled] = useState(false)
  const isSingle = group.length === 1
  const handleClick = () => {
    setToggled(!isToggled)
  }

  return (
    <div
      className={cx(styles.calendarGroup, {
        [styles.one]: isSingle,
        [styles.closed]: !isToggled,
      })}
    >
      {group.map((element, index) => {
        return (
          <div className={styles.itemRow} key={element.group.id + index}>
            {index === 0 && (
              <div
                data-testid='row-btn'
                className={cx(styles.itemHeader, {
                  [styles.closed]: !isToggled,
                })}
                onClick={handleClick}
              >
                <div className={styles.headerWrapper} />
                <span className={styles.headerTitle}>
                  {element.group.title}{' '}
                  <i
                    className={cx(
                      styles.arrowIcon,
                      'font-icons bottom-arrow-icon',
                      { [styles.toggled]: isToggled }
                    )}
                  />
                </span>
                <div className={styles.calendarList}>
                  {monthesShort.map((month) => (
                    <span className={styles.month} key={month}>
                      {isMobileDemention ? month.slice(0, 1) : month}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {isToggled && <CalendarContentRow element={element} />}
          </div>
        )
      })}
    </div>
  )
}
